import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Breadcrumbs from "./components/Breadcrumbs";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import KSB from "./pages/KSB";
import Clientes from "./pages/Clientes";
import SobreNosotros from "./pages/SobreNosotros";
import Terminos from "./pages/Terminos";

// TECNAL pages
import TECNALPage from "./pages/tecnal/TECNALPage";
import AlmacenamientoGranosPage from "./pages/tecnal/AlmacenamientoGranosPage";
import AceiteVegetalPage from "./pages/tecnal/AceiteVegetalPage";
import AlimentacionAnimalPage from "./pages/tecnal/AlimentacionAnimalPage";
import MovimientoPortuarioPage from "./pages/tecnal/MovimientoPortuarioPage";
import EtanolMaizPage from "./pages/tecnal/EtanolMaizPage";
import EquipmentPageWrapper from "./pages/tecnal/EquipmentPageWrapper";
import ReferenciaPage from "./pages/tecnal/ReferenciaPage";

// KSB pages
import BombasPage from "./pages/ksb/BombasPage";
import ValvulasPage from "./pages/ksb/ValvulasPage";
import KSBEquipmentPage from "./pages/ksb/KSBEquipmentPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Breadcrumbs />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sobre-nosotros" element={<SobreNosotros />} />
            <Route path="/clientes" element={<Clientes />} />
            <Route path="/terminos" element={<Terminos />} />
            
            {/* KSB main routes */}
            <Route path="/ksb" element={<KSB />} />
            <Route path="/ksb/bombas" element={<BombasPage />} />
            <Route path="/ksb/valvulas" element={<ValvulasPage />} />
            <Route path="/ksb/presurizacion" element={<KSBEquipmentPage />} />
            <Route path="/ksb/monitoreo" element={<KSBEquipmentPage />} />
            <Route path="/ksb/service" element={<KSBEquipmentPage />} />
            
            {/* KSB Equipment subpages */}
            <Route path="/ksb/:category/:equipment" element={<KSBEquipmentPage />} />
            
            {/* TECNAL main routes */}
            <Route path="/representaciones/tecnal" element={<TECNALPage />} />
            <Route path="/representaciones/tecnal/almacenamiento-de-granos" element={<AlmacenamientoGranosPage />} />
            <Route path="/representaciones/tecnal/aceite-vegetal" element={<AceiteVegetalPage />} />
            <Route path="/representaciones/tecnal/alimentacion-animal" element={<AlimentacionAnimalPage />} />
            <Route path="/representaciones/tecnal/movimiento-portuario" element={<MovimientoPortuarioPage />} />
            <Route path="/representaciones/tecnal/etanol-de-maiz" element={<EtanolMaizPage />} />
            
            {/* TECNAL Referencias routes */}
            <Route path="/representaciones/tecnal/referencias/:referencia" element={<ReferenciaPage />} />
            
            {/* TECNAL Equipment individual pages - dynamic routes */}
            <Route path="/representaciones/tecnal/:category/:equipment" element={<EquipmentPageWrapper />} />
            
            {/* Legacy route redirect */}
            <Route path="/tecnal" element={<TECNALPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
